import {columnsTable as columnsTable_v1,subTitlesTable as subTitlesTable_v1} from './columns_PROOBJTEND';
import {columnsTable as columnsTable_v2,subTitlesTable as subTitlesTable_v2} from './columns_PROOBJTEND_v2';
import {columnsTable as columnsTable_v3,subTitlesTable as subTitlesTable_v3} from './columns_PROOBJTEND_v3';

export const columnsTable = (año, idVersion) => {
    console.log('columnsTable_v1(año)', columnsTable_v1(año));
    switch (idVersion) {
        case 1:
            return columnsTable_v1(año);
        case 2:
            return columnsTable_v2(año);
        case 3:
            return columnsTable_v3(año);
        default: 
            return columnsTable_v1(año);
    }
}

export const subTitlesTable = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return subTitlesTable_v1(año);
        case 2:
            return subTitlesTable_v2(año);
        case 3:
            return subTitlesTable_v3(año);
        default: 
            return subTitlesTable_v1(año);
    }
}